import { render, staticRenderFns } from "./SelecionarTipoPedido.vue?vue&type=template&id=29d5c91a&"
import script from "./SelecionarTipoPedido.vue?vue&type=script&lang=js&"
export * from "./SelecionarTipoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports